import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'da',
  fallbackLocale: 'da',
  missing: (locale, val) => {
    if (process.env.NODE_ENV === 'development') {
      return val;
    }
    return '';
  },
  messages: {},
});

window.i18n = i18n;

(async function loadDictionaries() {
  try {
    const lang = await window.axios.get('/api/dictionary/getAll');
    const dict = {
      ...lang.data,
    };
    Object.keys(window.dictionaries).forEach((key) => {
      dict[key] = { ...window.dictionaries[key], ...dict[key] };
    });

    i18n.setLocaleMessage('da', dict);
    i18n.locale = 'da';
  } catch (error) {
    console.log('error.response :>> ', error.response);
  }
})();

export default i18n;
